<template>
  <div class="quickSenseContainer">
    <div class="columns" v-if="data">
      <div class="column columnLeft is-half">
        <div class="costLimitContainer">
          <p class="subtitle">{{ $t("quickSense.cost.title") }}</p>
          <p>{{ $t("quickSense.cost.subtitle") }}</p>
          <h1 style="text-align: right" class="title">
            {{ currencyLabel }} {{ cost }}
          </h1>

          <range-input
            :step="step"
            :min="minCost"
            :max="maxCost"
            v-model="cost"
          >
          </range-input>
          <span class="rangeMin">{{ currencyLabel }} {{ minCost }}</span>
          <span class="rangeMax is-pulled-right">
            {{ currencyLabel }} {{ maxCost }}
          </span>
        </div>
        <br />
        <br />

        <div class="consumptionContainer">
          <p class="subtitle">{{ $t("quickSense.bars.title") }}</p>
          <p>
            <small>{{ $t("quickSense.bars.subtitle") }}</small>
          </p>
          <br />
          <progress-bar
            color="#57B04C"
            :data="data.radiator"
            :long="true"
            :currency="currencyLabel"
          ></progress-bar>
          <br />
          <progress-bar
            color="#E5A725"
            :data="data.towel"
            :long="true"
            :currency="currencyLabel"
          ></progress-bar>
          <br />
          <progress-bar
            color="#AF77B0"
            :data="data.therm"
            :long="true"
            :currency="currencyLabel"
          ></progress-bar>
          <br />
          <progress-bar
            color="#69B9E8"
            :data="data.acs"
            :long="true"
            :currency="currencyLabel"
          ></progress-bar>
          <br />
        </div>
      </div>
      <div class="column columnRight">
        <radial-progress-bar
          style="display: block; margin: 0 auto"
          :diameter="500"
          :values="radialValues"
          :total-steps="100"
        >
          <h1 class="title">
            {{ decimal(data.total.cost) }} {{ currencyLabel }}
          </h1>
          <p class="subtitle">{{ decimal(data.total.consumption) }} kwh</p>
        </radial-progress-bar>

        <br /><br />
        <a
          @click="
            $router.push(
              '/installations/' + installation['.key'] + '/statistics'
            )
          "
          class="button is-rounded is-success"
        >
          {{ $t("quickSense.detailsLink") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import constants from "../../config/constants";
import RangeInput from "@/components/shared/RangeInput.vue";
import RadialProgressBar from "@/components/shared/RadialProgressBar.vue";
import ProgressBar from "../shared/ProgressBar";
import zapp from "@/util/zapp";

export default {
  components: {
    ProgressBar,
    RangeInput,
    RadialProgressBar,
  },
  name: "quicksense",
  props: ["currency"],

  data() {
    let currency = constants.currency[this.currency];
    if (!currency) currency = "€";

    return {
      currencyLabel: currency,
    };
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
    }),

    ...mapState("statistics", {
      data: "quickSense",
      maxCost: "maxCost",
      step: "maxCostStep",
      minCost: "maxCostStep",
    }),

    radialValues: function () {
      let today = new Date();
      let lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      ).getDate();
      return {
        inner: {
          color: "#306922",
          value: (100 * this.cost) / this.maxCost, //CHECK IF THIS this.cost < maxCost to prevent overdraw circle
        },
        middle: {
          color: "#429321",
          value: (100 * this.data.total.cost) / this.maxCost,
        },
        outer: {
          color: "#dbdbdb",
          value: (100 * today.getDate()) / lastDayOfMonth,
        },
      };
    },

    cost: {
      set(value) {
        this.updateCost({ installation: this.installation, cost: value });
        this.$forceUpdate();
      },
      get() {
        return this.installation.cost_limit;
      },
    },
  },
  methods: {
    ...mapActions("installations", ["updateCost", "setQuickSense"]),

    decimal: (number) => zapp.getFormattedDecimal(number),
  },

  mounted() {
    this.setQuickSense();
  },
};
</script>

<style lang="scss" scoped>
.quickSenseContainer {
  padding: 0 2rem 2rem;
}

.costLimitContainer,
.consumptionContainer {
  background-color: #efefef;
}

.costLimitContainer,
.consumptionContainer {
  text-align: left;

  background-color: #efefef;
  border-radius: 15px;
  padding: 1rem;

  .vue-range {
    width: 85%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 600px) {
  .columnRight {
    position: absolute;
    left: calc(50% - 250px);
  }
}
</style>
